import { Link } from 'react-router-dom'

export default function SvLink(props) {
	return (
		<Link {...props} style={{ textDecoration: 'none', color: 'inherit' }} />
	);
}